import { Signal } from "./signal.js";
export const DEFAULT_GAME_SETTINGS = {
    enabled: { hiss: true, airy: true, pop: true, hum: true },
    speed: 0.6,
    perfectMs: 45,
    windowMs: 220,
    basePoints: 100,
    comboCap: 20,
    length: 12,
    infinite: false,
    spawnIntervalBeats: 1,
    sustainChance: 0.4,
    breakBeats: 1,
    sustainWeight1: 1,
    sustainWeight2: 1,
    sustainWeight4: 1,
    sustainWeight8: 0.5,
    classifierC: 2.0,
    classifierGamma: 2.0,
    classifierRejectConfidence: 0.45,
    classifierTestFraction: 0,
    classifierImpulseCBoost: 6.0,
};
export const DEFAULT_DESIGNED_STAGE = {
    title: "My Stage",
    tempoBpm: 90,
    windowMs: 220,
    notes: [],
};
export const store = {
    route: new Signal("home"),
    theme: new Signal("child"),
    calibrated: new Signal(false),
    timed: new Signal(true),
    activeCourse: new Signal(null),
    gameSettings: new Signal({ ...DEFAULT_GAME_SETTINGS }),
    hud: new Signal({
        agility: 0,
        combo: 0,
        recovery: 1,
        precision: 0,
        score: 0,
        consistency: 0,
        lastVerdict: "none",
        lastGain: 0,
        lastOffsetMs: 0,
        lastEventAt: 0,
    }),
    a11y: new Signal({
        haptics: false,
        reducedMotion: typeof matchMedia !== "undefined"
            ? matchMedia("(prefers-reduced-motion: reduce)").matches
            : false,
        captions: false,
    }),
    usingWasm: new Signal(false),
    suggestedEnergyScale: new Signal(null),
    activeLanes: new Signal(["hiss", "airy", "pop", "hum"]),
    designedStage: new Signal(null),
    activeLibraryId: new Signal("default"),
    recordingSession: new Signal(null),
};
